import { render, staticRenderFns } from "./setpassword.vue?vue&type=template&id=0e3efd04&scoped=true"
import script from "./setpassword.vue?vue&type=script&lang=js"
export * from "./setpassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3efd04",
  null
  
)

export default component.exports